import { render, staticRenderFns } from "./BusinessOtherItemForm.vue?vue&type=template&id=01249574"
import script from "./BusinessOtherItemForm.vue?vue&type=script&lang=js"
export * from "./BusinessOtherItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports